<template>
  <div class="pay-tip-page" style="min-width: 1400px;
height: 2159px;
background: #def2fa;
position: relative;
z-index: 1;
">
    <div>
      <img class="pay-tip-hero" style="width: 811px;height: 638px;margin-top: 40px;" src="../assets/payMain.png" alt="">
    </div>
    <center>
      <div class="pay-tip-card" style="
      margin-top: -95px;
    position: relative;
    z-index: 10 !important;
    width: 1215px;
    height: 1555px;
    background-image: linear-gradient(#fff 80%, #def2fa);
">
  <span class="pay-tip-intro" style="height: 15px;
font-size: 14px;
font-family: Microsoft YaHei;
font-weight: bold;
color: #666666;
margin-top: 42px;
display: inline-block;
">【微思翻译】秉承“信，达，雅”翻译之要诀，拓展机器翻译之精髓。致力于为用户提供易操作，原格式，可编辑的优秀翻译文档。</span>
        <div>
          <img style="margin-top: 45px;" width="427px" height="33px" src="../assets/payTitle.png" alt="">
        </div>
        <div style="text-align: left;margin-left: 37px">
     <span style="text-align: left;width: 55px;
height: 18px;
font-size: 18px;
font-family: Microsoft YaHei;
font-weight: bold;
color: #333333;
">
       活动一
     </span>
        </div>
        <div style="text-align: left;margin-left: 37px">
  <span style="width: 233px;
height: 15px;
font-size: 14px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #666666;
">
    免费翻译三十页（首次注册个人用户）
  </span>
        </div>
        <div style="text-align: left;margin-left: 37px;margin-top: 20px;">
     <span style="text-align: left;width: 55px;
height: 18px;
font-size: 18px;
font-family: Microsoft YaHei;
font-weight: bold;
color: #333333;
">
       活动二
     </span>
          <span v-show="hasLogin" style="    width: 98px;
    height: 34px;
    background: rgb(24, 70, 135);
    border-radius: 6px 0px 0px 6px;
    font-size: 14px;
    font-family: Microsoft YaHei;
          font-weight: 400;
          color: rgb(255, 255, 255);
          float: right;
          text-align: center;
          line-height: 2.5;cursor: pointer" data-track-text="去充值" aria-label="去充值" @click="toCenter">
            去充值
          </span>
        </div>
        <div style="text-align: left;margin-left: 37px;font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;">
          <span style="margin-right: 76px">
            <span
              style="margin-right:3px;width: 10px;background-color: #6ebdff;display: inline-block;height: 10px;border-radius: 50%;"></span>
            充一百<span style="color: #ff0000;font-size: 18px">赠10</span>元
          </span>
          <span style="margin-right: 76px">
            <span
              style="margin-right:3px;width: 10px;background-color: #6ebdff;display: inline-block;height: 10px;border-radius: 50%;"></span>
            充二百<span style="color: #ff0000;font-size: 18px">赠25</span>元
          </span>
          <span style="margin-right: 76px">
            <span
              style="margin-right:3px;width: 10px;background-color: #6ebdff;display: inline-block;height: 10px;border-radius: 50%;"></span>
            充五百<span style="color: #ff0000;font-size: 18px">赠60</span>元
          </span>
          <span style="margin-right: 76px">
            <span
              style="margin-right:3px;width: 10px;background-color: #6ebdff;display: inline-block;height: 10px;border-radius: 50%;"></span>
            充一千<span style="color: #ff0000;font-size: 18px">赠200</span>元
          </span>
        </div>
        <div>
          <img style="margin-top: 109px" src="../assets/payExamp.png" width="150px" height="33px" alt="">
        </div>
        <div  style="text-align: left;margin-left: 37px">
          <span style="width: 509px;
height: 14px;
font-size: 14px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #666666;
">
翻译样例，左侧为原文，右侧为译文。阅读时，原文跟随译文滚动，方便对照阅读。
          </span>
        </div>
        <div class="pay-tip-samples">
          <div class="pay-tip-sample" style="
    float: left;width: 600px;
height: 801px;
background: #FFFFFF;
box-shadow: 0px 0px 50px 0px rgba(215, 228, 251, 0.5);
border-radius: 8px 8px 8px 0px;
">
            <img src="../assets/orig.png" alt="">
          </div>
          <div class="pay-tip-sample" style="
    float: left;width: 600px;
height: 801px;
background: #FFFFFF;
box-shadow: 0px 0px 50px 0px rgba(215, 228, 251, 0.5);
border-radius: 8px 8px 0px 8px;
">
            <img src="../assets/tran.png" alt="">

          </div>
        </div>
        <div class="pay-tip-decoration" style="    z-index: -1;
    position: absolute;
    left: -60px;
    top: 1300px;
    width: 193px;
    height: 193px;
    border-radius: 50%;
    background-image: linear-gradient(to right bottom, rgb(62, 134, 232), rgb(222, 242, 250) 50%);
">
        </div>
      </div>
    </center>
  </div>

</template>

<script>
  import {authServiceClient} from "../tools/api/service";
  import {userStatusRequest} from "../tools/api/auth-api";

  export default {
    name: "PayTip",
      data(){
        return{
            hasLogin:false,
        }
      },
      created() {
          const token = localStorage.getItem("token")
          const context = localStorage.getItem("auth-context")
          if(token!==undefined&&context!==undefined){
              this.hasLogin = true;
          }
      },
      methods:{
          toCenter(){
              let token = localStorage.getItem("token");
              if(token===undefined||token===null||token===""){
                  this.showIframe("/login")
                  return;
              }
              this.isUserLogin()
          },
          isUserLogin() {
              const TOKEN_KEY = 'token';
              authServiceClient.getUserStatus(userStatusRequest, {
                  [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
              }).then(res => {
                  if (!res.getStatus()) {
                      this.showIframe("/login")
                      return
                  }
                  const user = localStorage.getItem('auth-context');
                  if (!user) {
                      this.showIframe("/login")
                      return
                  }
                  const hasLogin = user.includes('Person')||user.includes('Child');
                  if(!hasLogin){
                      this.showIframe("/login")
                      return
                  }
                  window.open("http://user.wesitrans.com", '_blank')
              }).catch(err => {
                  this.showIframe("/login")
              });
          },
          showIframe(url) {
              return this.$authPopup.open(url, { area: ['948px', '501px'] })
          },
      }
  }
</script>

<style lang="less" scoped>
@media (max-width: 768px) {
  .pay-tip-page {
    width: 100%;
    min-width: 0 !important;
    height: auto !important;
    min-height: 100vh;
    padding: 16px 12px calc(76px + env(safe-area-inset-bottom));
    overflow-x: hidden;
    box-sizing: border-box;
  }

  .pay-tip-hero {
    width: 100% !important;
    height: auto !important;
    margin-top: 0 !important;
    display: block;
    object-fit: contain;
  }

  .pay-tip-card {
    width: 100% !important;
    height: auto !important;
    min-height: 0;
    margin-top: -24px !important;
    padding: 30px 14px 20px;
    border-radius: 12px;
    box-sizing: border-box;
  }

  .pay-tip-card > span,
  .pay-tip-card > div {
    max-width: 100%;
    margin-right: 0 !important;
    margin-left: 0 !important;
    box-sizing: border-box;
  }

  .pay-tip-intro {
    display: block !important;
    width: 100%;
    height: auto !important;
    margin-top: 0 !important;
    line-height: 1.7;
    text-align: left;
  }

  .pay-tip-decoration {
    display: none;
  }

  .pay-tip-card img {
    max-width: 100%;
    height: auto;
  }

  .pay-tip-card > div:nth-of-type(5) {
    display: flex;
    flex-wrap: wrap;
    gap: 8px 14px;
  }

  .pay-tip-card > div:nth-of-type(5) > span {
    margin-right: 0 !important;
  }

  .pay-tip-samples {
    display: grid;
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .pay-tip-sample {
    width: 100% !important;
    height: auto !important;
    float: none !important;
  }

  .pay-tip-sample > img {
    width: 100%;
    display: block;
  }
}
</style>
